import { useEffect, useState } from 'react'

import type { BraintreeError } from 'braintree-web'
import { create as braintreeClientCreate } from 'braintree-web/client'

import { BraintreeInstanceConfig } from './types'

export const useBraintreeClient = (clientToken?: string) => {
    const [btClientInstanceConfig, setBtClientInstanceConfig] = useState<BraintreeInstanceConfig | undefined>(undefined)
    const [isBtClientLoading, setIsBtClientLoading] = useState(true)
    const [btClientInstanceError, setBtClientInstanceError] = useState<BraintreeError | unknown>()

    useEffect(() => {
        if (!clientToken) return

        braintreeClientCreate(
            {
                authorization: clientToken,
            },
            (createErr, clientInstance) => {
                setBtClientInstanceConfig(clientInstance.getConfiguration())
                setBtClientInstanceError(createErr)
                setIsBtClientLoading(false)
            },
        )
    }, [clientToken])

    return { btClientInstanceConfig, isBtClientLoading, btClientInstanceError }
}
